import { render } from "./Uis.vue?vue&type=template&id=00edaa16"
import script from "./Uis.vue?vue&type=script&lang=js"
export * from "./Uis.vue?vue&type=script&lang=js"
script.render = render

export default script